import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
import { hasSchemaACL } from '@frontend/auth-helpers';
import { useAppScopeStore, useScopedAppFlagStore } from '@frontend/scope';

export const useAiSettingsAccess = () => {
  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const { selectedLocationIds } = useAppScopeStore();

  const hasAiReceptionistACL = selectedLocationIds.some((locationId) =>
    hasSchemaACL(locationId, Permission.AI_SETTINGS_WRITE)
  );

  const hasBridgeLineFlag = getFeatureFlagValue('bridgeline-settings');

  const hasAiSettingsAccess = hasBridgeLineFlag && hasAiReceptionistACL;

  return {
    hasAiSettingsAccess,
  };
};
